import { useIntl } from 'react-intl';

import { Badge } from 'src/registry/ui/Badge';
import { generalMessages } from 'src/registry/utils/messages';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function BooleanBadge ({ booleanField }: { booleanField?: boolean }) {
    const { formatMessage } = useIntl();

    return (
        <Badge theme={booleanField ? 'green' : 'red'}>
            <FontAwesomeIcon icon={booleanField ? faCircleCheck : faCircleXmark} />
            {formatMessage(booleanField ? generalMessages.yes : generalMessages.no)}
        </Badge>
    );
};
